import React, { useState, useEffect } from 'react';
import Modal from 'react-awesome-modal';
import { updateTemplate } from '../../../Services/IBS/IbsService';

export const NotesModal = ({ notesModalShow, setNotesModalShow, row, updateRow, inProcess = false }) => {
    const [textValue, setTextValue] = useState(row.analystComments ? row.analystComments : '');

    useEffect(() => {
        setTextValue(row.analystComments ? row.analystComments : '');
    }, [row.analystComments]);

    const handleKeyDown = (e) => {
        let maxHeight = Math.round((window.innerHeight * 0.6) / 100) * 100;
        let minHeight = Math.round((window.innerHeight * 0.15) / 100) * 100;
        e.target.style.height = 'inherit';
        e.target.style.height = `${Math.max(minHeight, Math.min(e.target.scrollHeight, maxHeight))}px`;
        setTextValue(e.target.value)
        // In case you have a limitation
        // e.target.style.height = `${Math.min(e.target.scrollHeight, limit)}px`;
    }

    const textRowCount = textValue ? textValue.split("\n").length : 5;

    return (<Modal
        width="950"
        className="testClass"
        effect="fadeInDown"
        visible={notesModalShow}
    >
        <div className="commentModal notesModal" id="notesModal">
            <h3> <i className="fa fa-edit"></i> Notes</h3>
            <hr />
            <textarea
                rows={textRowCount}
                value={textValue}
                style={{ minHeight: '16vh', height: 'unset' }}
                onChange={(e) => {
                    handleKeyDown(e)
                }}></textarea>
            <button type="button" className="btn btn-close blue" onClick={async () => {
                let updatedRow = { ...row, analystComments: textValue, inProcess };
                updateTemplate(updatedRow)
                if (updateRow) {
                    updateRow(updatedRow)
                }
                setNotesModalShow(false)
            }}>Save</button>
            <button type="button" className="btn btn-close orange" onClick={() => {
                setTextValue(row.analystComments ? row.analystComments : '')
                setNotesModalShow(false)
            }}>Cancel</button>
        </div>
    </Modal>)
}